
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const ConsultationPage = lazy(() => import('../pages/consultation/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Service pages
const WeightLossPage = lazy(() => import('../pages/services/weight-loss/page'));
const IVTherapyPage = lazy(() => import('../pages/services/iv-therapy/page'));
const PeptideTherapyPage = lazy(() => import('../pages/services/peptide-therapy/page'));
const SexualWellnessPage = lazy(() => import('../pages/services/sexual-wellness/page'));
const MentalHealthPage = lazy(() => import('../pages/services/mental-health/page'));
const HairGrowthPage = lazy(() => import('../pages/services/hair-growth/page'));
const LongevityPage = lazy(() => import('../pages/services/longevity/page'));

// Blog pages
const BlogPage = lazy(() => import('../pages/blog/page'));
const PeptideTherapyWeightLossPage = lazy(() => import('../pages/blog/peptide-therapy-weight-loss/page'));
const TopIVInfusionsPage = lazy(() => import('../pages/blog/top-iv-infusions-energy-immunity/page'));
const MentalHealthIntegrativePage = lazy(() => import('../pages/blog/mental-health-integrative-approach/page'));
const HairRestorationTreatmentsPage = lazy(() => import('../pages/blog/hair-restoration-treatments-that-work/page'));
const TruthAboutWeightLossInjectionsPage = lazy(() => import('../pages/blog/truth-about-weight-loss-injections/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/consultation',
    element: <ConsultationPage />
  },
  {
    path: '/booking',
    element: <BookingPage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '/services/weight-loss',
    element: <WeightLossPage />
  },
  {
    path: '/services/iv-therapy',
    element: <IVTherapyPage />
  },
  {
    path: '/services/peptide-therapy',
    element: <PeptideTherapyPage />
  },
  {
    path: '/services/sexual-wellness',
    element: <SexualWellnessPage />
  },
  {
    path: '/services/mental-health',
    element: <MentalHealthPage />
  },
  {
    path: '/services/hair-growth',
    element: <HairGrowthPage />
  },
  {
    path: '/services/longevity',
    element: <LongevityPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/peptide-therapy-weight-loss',
    element: <PeptideTherapyWeightLossPage />
  },
  {
    path: '/blog/top-iv-infusions-energy-immunity',
    element: <TopIVInfusionsPage />
  },
  {
    path: '/blog/mental-health-integrative-approach',
    element: <MentalHealthIntegrativePage />
  },
  {
    path: '/blog/hair-restoration-treatments-that-work',
    element: <HairRestorationTreatmentsPage />
  },
  {
    path: '/blog/truth-about-weight-loss-injections',
    element: <TruthAboutWeightLossInjectionsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
